import { Repair } from '@damofire/data-watson';
import { CanvasCoordinates, CanvasDisplayPrecision, CanvasRenderer, CanvasRenderingCtx } from '@damofire/uix-commons';
import { DEFAULT_REPAIR_CFG, SELECTED_ISSUE_SCALE } from './canvas.cfg';

export interface LayoutRepairs extends CanvasCoordinates {
  assetId: string;
  size: number;
  repairs: Repair[];
}

export class RepairLayoutRenderer extends CanvasRenderer {
  private _selected = false;

  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    private readonly repairs: LayoutRepairs,
  ) {
    super();
  }

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();
    this.repairs.size = DEFAULT_REPAIR_CFG.size * (this._selected ? SELECTED_ISSUE_SCALE : 1);

    this.ctx.translate(this.repairs.x, this.repairs.y);
    if (this._selected) {
      const selectedSize = DEFAULT_REPAIR_CFG.size * SELECTED_ISSUE_SCALE + 10;
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.rect(-selectedSize / 2, -selectedSize / 2, selectedSize, selectedSize);
      this.ctx.globalAlpha = 0.6;
      this.ctx.fillStyle = DEFAULT_REPAIR_CFG.fill;
      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.restore();
    }

    const size = this.repairs.size;

    this.ctx.beginPath();
    this.ctx.rect(-size / 2, -size / 2, size, size);
    this.ctx.fillStyle = DEFAULT_REPAIR_CFG.fill;
    this.ctx.fill();
    this.ctx.closePath();

    if (renderingCtx.precision === CanvasDisplayPrecision.FULL) {
      this.ctx.fillStyle = 'white';
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';
      this.ctx.font = `bold ${size / 2}px Open Sans`;
      this.ctx.scale(1, -1);
      this.ctx.rotate(-renderingCtx.rx * (Math.PI / 180));
      this.ctx.fillText(`${this.repairs.repairs.length}`, 0, 0);
    }

    this.ctx.restore();
  }

  set selected(selected: boolean) {
    this._selected = selected;
  }

  layoutRepairs(): LayoutRepairs {
    return this.repairs;
  }

  allRepairs(): Repair[] {
    return Object.assign([], this.repairs.repairs);
  }

  updateRepairs(repairs: Repair[]): void {
    this.repairs.repairs = Object.assign([], repairs);
  }
}
